import { render, staticRenderFns } from "./menuManager.vue?vue&type=template&id=3f00b7c0"
import script from "./menuManager.vue?vue&type=script&lang=js"
export * from "./menuManager.vue?vue&type=script&lang=js"
import style0 from "./menuManager.vue?vue&type=style&index=0&id=3f00b7c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_30effc9705e4bf7ead9172d765b7e483/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports